// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"9b80c813","459":"74556b5d","491":"5c7a0a60","503":"d6753418","601":"0cc37054","801":"31d5507b","895":"742c444f","938":"b036b2d1"}[chunkId] + ".chunk.js";
};